import React, { useRef } from "react";
import {
  Drawer,
  DrawerContent,
  useDisclosure,
} from "@heroui/react";
import { ReactComponent as Close } from "../../assets/close.svg";
import { isIOS, isMobile } from "react-device-detect";
import { toast } from "sonner";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";
import { isInAppBrowser } from "../../lib/inAppBrowser";


interface Props {
  children: string;
  link: string; // Novo parâmetro
  onClick?: () => void;
}

const ContractModal: React.FC<Props> = ({ children, link, onClick }) => {

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();


  const { external_link } = useStore();


  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const startTimeRef = useRef<number | null>(null);
  const stopInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };


  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}
      <span className="text-green-dark text-700 underline cursor-pointer"
        onClick={() => {
          onClick && onClick();
          AmplitudeLog("Checkout_Modal_Visualizado", { nome_modal: children });
          startTimeRef.current = Date.now();

          if (isInAppBrowser(navigator.userAgent)) {
            toast(
              "Para ler o contrato, toque em ⋮ (ou no ícone de compartilhar) e escolha \"Abrir no navegador\".",
              { className: "!bg-blue-primary !text-white-primary" }
            );
            return;
          }

          isIOS ? window.open(link, "_blank") : onOpen();
        }}
      >{children}</span>
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
        onClose={() => {
          const tempoLeitura = startTimeRef.current ? Math.floor((Date.now() - startTimeRef.current) / 1000) : 0;
          AmplitudeLog("Checkout_Modal_Fechado", {
            nome_modal: children,
            tempo_de_leitura_segundos: tempoLeitura
          });
          startTimeRef.current = null;
          stopInterval();
        }}
      >
        <DrawerContent
          className={`
            w-ful
            rounded-t-[0.75rem]
            !max-h-screen ${!isMobile && "!h-[100vh] !rounded-none !border-none"
            }
            bg-white-primary
            px-[2rem]
            pb-[2rem]
            flex
            items-center
          `}
        >
          {(onClose) => (
            <div className={`${external_link && !isMobile ? "w-[60%]" : "w-full"}`}
            >
              <div className="w-[100%] flex flex-col items-center ">
                <div className="w-[100%] flex flex-col items-end">
                  <button
                    onClick={() => onClose()}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      marginTop: "1.5rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <Close className="w-[1rem] h-[1rem]" />
                  </button>
                </div>
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className="text-green-dark text-sm underline mb-[0.75rem]"
                >
                  Não conseguiu visualizar? Toque aqui para baixar o PDF
                </a>
                <div className="w-full mt-4 flex justify-center bg-red-primary">
                  <iframe
                    title="Contrato de Aquisição"
                    src={link} // Usando o link recebido como prop
                    className={`w-full ${isMobile ? "h-[70vh]" : external_link ? "h-[80vh]" : "h-[90vh]"}`}
                    style={{ border: "none" }}
                  />
                </div>
              </div>
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default ContractModal;
